import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core';
import { MyProductUsage, ProductUsageService2 } from '@dch/ng-usage';
import { TranslationService } from '@proximus/ng-common';
import {
  ReportingCategoryGroup,
  TimeLeft,
  UsageDetails,
} from '@proximus/usage-business-logic';
import { combineLatest, Observable, of, throwError } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';
import { Alert } from '@proximus/ng-common-components';
import { savePii } from 'src/app/shared/pii/pii.utils';
import { Router } from '@angular/router';

const FLEX_EMERGENCY_MPCUUID = 'MEGMK';
@Component({
  selector: 'mprd-flex-product-card',
  templateUrl: './flex-product-card.component.html',
})
export class FlexProductCardComponent implements OnInit, OnChanges {
  @Input() product: any;
  @Input() oneAlreadyActive: boolean;
  @Output('checkForOneActive') checkForOneActive: EventEmitter<any> =
    new EventEmitter();
  productUsage$: Observable<MyProductUsage>;
  isActive = false;
  timeRemaining: TimeLeft;
  hasEmergencyInternetSessionValidity = false;
  hasEmergencyInternetSessionLeft = false;
  hasEmergencyInternetSessionUsed = false;
  showSessionsSection = false;
  isLoading = true;
  hasError = false;
  alerts: Alert[] = [];
  class = 'rs-btn rs-btn-order rs-no-margin-bottom-m';

  constructor(
    private productUsageService: ProductUsageService2,
    public translationService: TranslationService,
    private changeDetectorRef: ChangeDetectorRef,
    private router: Router,
  ) {}

  ngOnInit(): void {
    if (this.oneAlreadyActive) {
      this.class = 'rs-btn rs-btn-disabled rs-no-margin-bottom-m';
    }
    if (this.product) {
      this.productUsage$ = this.productUsageService.getSelectedProductUsage(
        this.product,
        'productDetails',
      );
      combineLatest(this.productUsage$)
        .pipe(
          map(([productUsage]) => {
            const usageDetails =
              this.getFlexEmergencyAccumulatorById(productUsage);
            const timeLeft = new UsageDetails(usageDetails).getTimeLeft();
            this.isActive = !!usageDetails;
            this.timeRemaining = timeLeft;
            this.isLoading = false;
            this.hasEmergencyInternetSessionValidity =
              !!this.product.emergencyInternetSessionValidity;
            this.hasEmergencyInternetSessionLeft =
              !!this.product.emergencyInternetSessionLeft;
            this.hasEmergencyInternetSessionUsed =
              !!this.product.emergencyInternetSessionUsed;
            this.showSessionsSection =
              (this.hasEmergencyInternetSessionValidity &&
                this.hasEmergencyInternetSessionLeft) ||
              this.hasEmergencyInternetSessionUsed;
          }),
          catchError(() => {
            this.addAlert(
              this.productUsageService.getAlert(
                'error',
                'MV',
                'usage.details.productRedStatusAlertDescription',
                'usage.details.productRedStatusAlertTitle',
              ),
            );
            this.hasError = true;
            return of(throwError('cannot fetch product usage'));
          }),
          finalize(() => {
            this.isLoading = false;
            this.changeDetectorRef.markForCheck();
          }),
        )
        .subscribe();
    }
  }

  ngOnChanges(): void {
    this.checkForOneActive.emit();
    if (this.oneAlreadyActive) {
      this.class = 'rs-btn rs-btn-disabled rs-no-margin-bottom-m';
    } else {
      this.class = 'rs-btn rs-btn-order rs-no-margin-bottom-m';
    }
  }

  activateProduct() {
    savePii(this.product.accessNumber);
    this.router.navigate(['/pxsplus/flex-emergency-activation']);
  }

  getFlexEmergencyAccumulatorById(productUsage: MyProductUsage) {
    const reportingCategories = this.getReportingCategories(productUsage);

    const isFlexEmergencyActive =
      this.isFlexEmergencyActive(reportingCategories);

    return isFlexEmergencyActive ? reportingCategories : undefined;
  }

  getReportingCatergoryGroup(
    productUsage: MyProductUsage,
  ): ReportingCategoryGroup {
    return productUsage.reportingCategoryGroups.find(
      (item) => item.code === 'data',
    );
  }

  getReportingCategories(productUsage: MyProductUsage): UsageDetails {
    const reportingCategoryGroup =
      this.getReportingCatergoryGroup(productUsage);

    return reportingCategoryGroup.reportingCategories.find(
      (item) => item.code === 'data.extra.osb',
    );
  }

  isFlexEmergencyActive(reportingCategories: UsageDetails): boolean {
    return (
      reportingCategories?.instances &&
      reportingCategories?.instances.some((instance) => {
        // @ts-ignore
        return (
          instance &&
          instance.relatedMpcUuid?.toUpperCase() === FLEX_EMERGENCY_MPCUUID
        );
      })
    );
  }

  public getTimeLeftTranslation() {
    return this.translationService
      .getTranslatedValueFor('flexEmergency.manage.24hoursLabel')
      .replace(
        /\{0\}/g,
        isNaN(this.timeRemaining.totalHours)
          ? 0
          : this.timeRemaining.totalHours,
      );
  }

  private addAlert(alert: Alert) {
    if (
      alert &&
      !this.alerts.find((existingAlert) => existingAlert.id === alert.id)
    ) {
      this.alerts.push(alert);
    }
  }
}
